import dateObjectFromDateString from './dateObjectFromDateString';

const minimumYear = (date: string | DayMonthYear) => {
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 100;
  const maxYear = currentYear - 18;
  const { year } =
    typeof date === 'string' ? dateObjectFromDateString(date) : date;
  if (year < minYear || year > maxYear) {
    return { isValid: false, year, currentYear };
  }
  return { isValid: true, year, currentYear };
};

export default minimumYear;
